import { Button, Select, Table } from 'antd'
import React, { Suspense } from 'react'

import { Loading } from './Loading'

type FallbackType = 'default' | 'table' | 'select' | 'button' | 'none'

export const SuspenseWithLoading: React.FC<{
  children: React.ReactElement
  type?: FallbackType
  loadingText?: string
}> = ({ children, type, loadingText }) => {
  switch (type) {
    case 'table':
      return <Suspense fallback={<Table loading />}>{children}</Suspense>
    case 'select':
      return <Suspense fallback={<Select loading />}>{children}</Suspense>
    case 'button':
      return <Suspense fallback={<Button loading>{loadingText ?? ''}</Button>}>{children}</Suspense>
    case 'none':
      // ErrorBoundaryForSuspenseを使うだけ
      // このtypeを選択するなら、わざわざこのコンポーネントを使う意味があまりないが、共通化のため一応定義しておく
      return <Suspense>{children}</Suspense>
  }

  return <Suspense fallback={<Loading />}>{children}</Suspense>
}
